/* Vixxa — içerik kopyalama caydırıcı. Tam koruma değildir; sağ tık, sürükle-bırak, seçim ve kaynak kısayollarını kapatır. */
(() => {
  if (window.Shopify && Shopify.designMode) return; // tema düzenleyicide kapalı
  document.documentElement.classList.add('vx-guard');
  const free = (el) => !!(el && el.closest && el.closest('input, textarea, select, [contenteditable], .legal'));
  document.addEventListener('contextmenu', (e) => { if (!free(e.target)) e.preventDefault(); });
  document.addEventListener('dragstart', (e) => { if (e.target && e.target.tagName === 'IMG') e.preventDefault(); });
  document.addEventListener('selectstart', (e) => { if (!free(e.target)) e.preventDefault(); });
  document.addEventListener('copy', (e) => { if (!free(document.activeElement) && !free(window.getSelection()?.anchorNode?.parentElement)) e.preventDefault(); });
  document.addEventListener('keydown', (e) => {
    const k = (e.key || '').toLowerCase(), mod = e.ctrlKey || e.metaKey;
    if (e.key === 'F12') { e.preventDefault(); return; }
    if (mod && e.shiftKey && ['i', 'j', 'c'].includes(k)) { e.preventDefault(); return; }
    if (mod && ['u', 's'].includes(k)) { e.preventDefault(); return; }
    if (mod && ['c', 'a', 'x'].includes(k) && !free(e.target)) { e.preventDefault(); }
  });
  try { console.log('%cVixxa', 'font:600 28px serif;color:#b3122e', '\nBu sitedeki görseller, metinler ve tasarım Vixxa / MED Group\'a aittir. İzinsiz kopyalanması 5846 sayılı FSEK kapsamında yasaktır.'); } catch (e) {}
})();
